// Imports
var ___CSS_LOADER_API_IMPORT___ = require("./node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n  font-family: Roboto, sans-serif;\n}\n\n.sticky-footer {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n}\n\n.tippy-tooltip-content {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
